
export interface UnderwriterMain {
 index: number;
 schedule: UnderwriterSchedule[];
}

export interface UnderwriterSchedule {
 index: number;
 'email address'?: string;
 'first name': string;
 'last name'?: string;
 mobile?: string;
 'session id': string;
 status?: string;

 current_amount?: string;
 header?: string;
 note_count?: number;
 prev_amount?: string;
 wording_count?: number;

 class_id?: number;
 description?: string;
 item_id?: number;
 status_description?: string;
 wording_data?: any;
 note_data?: any;
}

export interface WordingData {
  date_updated?: string;
  session_id?: string;
  wording_category?: string;
  wording_collation_id?: number;
  wording_html?: string;
  wording_id?: number;
  wording_rel_id?: number;
  wording_text?: string;
  wording_type?: string;
}

export interface NoteData {
  uw_notes_id: number;
	person_id: number;
	first_name: string;
	last_name: string;
	session_id: string;
	thread_id: number;
	note_type: number;
	note_data: string;
	public_flag: number;
	resolved_flag: number;
	date_updated: string;
}

export class Question {
  skipped: number;
  skipped_details: any;
  index: number;
  page: any;
  can_skip: any;
  call_proc: any;
  answer_proc: any;
  answer_count: any;
  parent_control: any;
  cent_aq_question_id: number;
  category_id: number;
  question_copy: string;
  question_copy_original: string;
  question_comment: string;
  itk: string;
  email_version: string;
  answer: string;
  add_another: number;
  flow_type_id: any;
  comment: string;
  comment_files: string;
  item_id: string;
  conditions: any;
  next: number;
  product_class_id: number;
  product_id: number;
  piped_question_id: number;
  question_prompt: string;
  question_bubble: string;
  question_hint: string;
  cent_aq_question_type_id: number;
  cent_aq_question_type: string;
  options: string;
  edit: number;
  item_schedule_section: any;
  excess_min: any;
  excess_max: any;
  excess_mod_min: any;
  excess_mod_max: any;
  val_min: any;
  val_max: any;
  max_val: any;
  min_val: any;
  excess: any;
  dependant_flow_id: any;
  parameter: string;
  parameters: string;
  uw: any;
  formated: string;
  wording_count: number;
  wording_data: any;
  changes_count: number;
  changes_data: any;
  header?: any;
  class_id?: any;
  question_image?: any;
  answer_id: number;
  flow_index: number;
  question_help: string;
  flow_id: number;
  hidden: number;
  page_index: number;
  saved = false;
  isEdit = false;
  interval: number;
  response_parameters;
  previous: number;
  session_id: string;
  vaps_id: number;
  location_id: number;
  location_bar: number;
  location_header: string;
  product_group_id: number;
  recommended?: number;
  flow_context?: string;
  highlight?: string;
  ai_evidence_type?: string;
  ai_schema_name?: string;
}

export interface FlowSessionDetails{
  session_id: string;
  state: string;
  category_id: number;
  flow_id: number;
  item_id: string;
  group_id: any;
  class_id: number;
  superflow_id: number;
}

export class VapQuestion {
  add_another: number;
  answer: string;
  answers: string;
  answers_parsed: VapQuestionAnswer[] = [];
  cent_aq_question_id: number;
  cent_aq_question_type: string;
  cent_aq_question_type_id: number;
  options: string;
  product_vaps_id: number;
  question_copy: string;
  question_help: string;
  question_prompt: string;
}

export class VapQuestionAnswer {
  answer: string;
}

export interface Answer {
  session_id: string;
  question_id: number;
  product_class_id: number;
  item_id: string;
  answer: string;
  answer_id: number;
  flow_id: number;
  comment: string;
  parameter: string;
}

export interface QuestionFlow {
  flow_id: number;
  superflow_id: number;
  next: number;
  call_proc: string;
  index: number;
}

export interface FlowItem{
  flow_id: number;
  questions: Question[];
}

export interface SuperflowItem {
  session_id: string;
  superflow_id: number;
  flow_items: FlowItem[];
}

export interface ShoppingCartItem {
  entry_type: string;
  class_id: number;
  flow_id: number;
  class_name: string;
  active: boolean;
  item_id: string;
  description: string;
  disc_flag: boolean;
  edit_flag: boolean;
  remove_flag: boolean;
  progress: any;
  premium: any;
  excess: any;
  shoppingcart_id: number;
}

export interface DamageImageModel {
  question: Question,
  header_copy: string,
  side: string,
  response: string,
  sender: string,
  other_side_name: string
}
